import React, { useState } from 'react';
import { KpeLayout } from '../../../_shared/components/KpeLayout/KpeLayout';
import { FactsHeader } from '../../components/FactsHeader/FactsHeader';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { ReactComponent as InfoIcon } from '../../../_shared/assets/icons/info-icon.svg';
import { FactsInputTable } from '../../components/FactsInputTable/FactsInputTable';
import { mockKpiFacts } from '../../../_shared/mocks';
import { KpiCalculationMethodModal } from '../../../_shared/components/KpiCalculationMethodModal/KpiCalculationMethodModal';
import styles from '../FactsPage/FactsPage.module.scss';

function FactsInputContent() {
  const [kpiData, setKpiData] = useState(mockKpiFacts);
  const [
    isCalculationMethodModalOpen,
    setIsCalculationMethodModalOpen
  ] = useState(false);

  const handleFactChange = (
    rowId: string,
    year: number,
    field: 'fact6months' | 'fact9months' | 'fact12months',
    value: number | null
  ) => {
    setKpiData((prev) =>
      prev.map((row) => {
        if (row.id !== rowId) return row;

        return {
          ...row,
          years: row.years.map((y) => {
            if (y.year !== year) return y;
            return {
              ...y,
              [field]: value,
              ...(field === 'fact12months' && { fact: value })
            };
          })
        };
      })
    );
  };
  const handleCalculationMethodClick = () => {
    setIsCalculationMethodModalOpen(true);
  };

  const handleCalculationMethodClose = () => {
    setIsCalculationMethodModalOpen(false);
  };
  return (
    <div className={styles.page}>
      <FactsHeader
        year={2027}
        status="Ввод фактических значений"
        lastUpdate="12.01.2027"
        factDeadline="до 20 января"
        appealDeadline="до 31 января"
        premiumDeadline="до 15 марта"
      />
      <div className={styles.head}>
        <div className={styles.headInfo}>
          <Typography variant="h2">Мои КПЭ</Typography>
          <Typography variant="text">
            Вам необходимо проверить и подтвердить фактические значения по
            показателям КПЭ за 2026 год.
            <br />
            Часть данных загружена автоматически из внутренних систем. При
            необходимости вы можете подать апелляцию.
          </Typography>
        </div>
      </div>
      <div className={styles.notification}>
        <span className={styles.notificationIcon}>
          <InfoIcon />
        </span>
        <Typography variant="text">
          Все изменения сохраняются автоматически. Вы можете покинуть страницу в
          любой момент — введённые данные не потеряются
        </Typography>
      </div>
      <FactsInputTable
        rows={kpiData}
        editable={true}
        onFactChange={handleFactChange}
        onKpiClick={(row) => console.log('Открыть детали', row)}
        onMethodologyClick={handleCalculationMethodClick}
      />
      <KpiCalculationMethodModal
        isOpen={isCalculationMethodModalOpen}
        onClose={handleCalculationMethodClose}
        notification={'Текст возможного уведомления'}
      />
    </div>
  );
}

export function FactsInputPage() {
  return (
    <KpeLayout>
      <FactsInputContent />
    </KpeLayout>
  );
}
